import React from 'react';
import '../Footer/Footer.css';



function Footer() {
  return (
    <div className='footer'>
        <div className='footer-div'>
            <div className='subBox'>
                <h3>something</h3>
                <ul>
                    <li>link1</li>
                    <li>link2</li>
                    <li>link3</li>
                    <li>link4</li>
                </ul>
            </div>
            <div className='subBox'>
                <h3>something2</h3>
                <ul>
                    <li>link1</li>
                    <li>link2</li>
                    <li>link3</li>
                    <li>link4</li>
                </ul>
            </div>
            <div className='subBox'>
                <h3>something3</h3>
                <ul>
                    <li>link1</li>
                    <li>link2</li>
                    <li>link3</li>
                    <li>link4</li>
                </ul>
            </div>
            <div className='subBox'>
                <h3>Type Here</h3>
                <input type='text' placeholder='Type here'/>
                <button type='sumbit'>Send</button>
            </div>
        </div>
    </div>
  )
}

export default Footer